import { render } from "./Dialog_MyContent.vue?vue&type=template&id=b2c90e18&scoped=true"
import script from "./Dialog_MyContent.vue?vue&type=script&lang=js"
export * from "./Dialog_MyContent.vue?vue&type=script&lang=js"

import "./Dialog_MyContent.vue?vue&type=style&index=0&id=b2c90e18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2c90e18"]])

export default __exports__